import { FETCH_PROMOTION_CODE } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PROMOTION_CODE:
      return { ...state, [action.payload.id]: action.payload }
    default:
      return state
  }
}
